module.exports = __webpack_public_path__ + "img/favorite-3.a1019bca.svg";